/**
 * Lower-stack series for the QXO roofing board.
 * Same units within each chart. Gaps stay null.
 * FRED pull 21 Sep 2026. Quarterly = average of months in the quarter.
 */

/** Census/HUD via FRED: PERMIT, HOUST, COMPUTSA. SAAR, millions of units. */
export const CONSTRUCTION_FUNNEL = [
  { period: 'Q1 19', permit: 1.278, starts: 1.179, complete: 1.288 },
  { period: 'Q2 19', permit: 1.323, starts: 1.269, complete: 1.236 },
  { period: 'Q3 19', permit: 1.443, starts: 1.309, complete: 1.227 },
  { period: 'Q4 19', permit: 1.5, starts: 1.409, complete: 1.288 },
  { period: 'Q1 20', permit: 1.434, starts: 1.465, complete: 1.261 },
  { period: 'Q2 20', permit: 1.221, starts: 1.08, complete: 1.195 },
  { period: 'Q3 20', permit: 1.574, starts: 1.465, complete: 1.336 },
  { period: 'Q4 20', permit: 1.686, starts: 1.567, complete: 1.343 },
  { period: 'Q1 21', permit: 1.772, starts: 1.57, complete: 1.368 },
  { period: 'Q2 21', permit: 1.692, starts: 1.584, complete: 1.337 },
  { period: 'Q3 21', permit: 1.685, starts: 1.591, complete: 1.31 },
  { period: 'Q4 21', permit: 1.785, starts: 1.668, complete: 1.346 },
  { period: 'Q1 22', permit: 1.889, starts: 1.708, complete: 1.318 },
  { period: 'Q2 22', permit: 1.762, starts: 1.636, complete: 1.377 },
  { period: 'Q3 22', permit: 1.619, starts: 1.465, complete: 1.41 },
  { period: 'Q4 22', permit: 1.468, starts: 1.392, complete: 1.445 },
  { period: 'Q1 23', permit: 1.498, starts: 1.373, complete: 1.478 },
  { period: 'Q2 23', permit: 1.503, starts: 1.457, complete: 1.458 },
  { period: 'Q3 23', permit: 1.552, starts: 1.385, complete: 1.396 },
  { period: 'Q4 23', permit: 1.513, starts: 1.469, complete: 1.469 },
  { period: 'Q1 24', permit: 1.532, starts: 1.41, complete: 1.564 },
  { period: 'Q2 24', permit: 1.44, starts: 1.342, complete: 1.641 },
  { period: 'Q3 24', permit: 1.454, starts: 1.34, complete: 1.694 },
  { period: 'Q4 24', permit: 1.471, starts: 1.388, complete: 1.594 },
  { period: 'Q1 25', permit: 1.467, starts: 1.397, complete: 1.599 },
  { period: 'Q2 25', permit: 1.42, starts: 1.356, complete: 1.46 },
  { period: 'Q3 25', permit: 1.397, starts: 1.347, complete: 1.463 },
  { period: 'Q4 25', permit: 1.438, starts: 1.323, complete: 1.442 },
  { period: 'Q1 26', permit: 1.432, starts: 1.418, complete: 1.379 },
  { period: 'Q2 26', permit: 1.402, starts: 1.345, complete: 1.376 },
  { period: 'Q3 26*', permit: 1.413, starts: 1.292, complete: 1.204 },
];

export const FUNNEL_LATEST = {
  month: 'Aug 2026',
  permit: 1.394,
  permitYoy: 3.5,
  complete: 1.128,
  completeYoy: -27.1,
  sfComplete: 0.816,
  notStarted: 0.276,
} as const;

/** Census regional starts SAAR, millions. South ≈ storm / Sunbelt roofing; Midwest is OC’s “good volume” pocket. */
export const REGIONAL_STARTS = [
  { period: 'Q1 19', south: 0.657, midwest: 0.139, west: 0.283, ne: 0.101 },
  { period: 'Q2 19', south: 0.671, midwest: 0.169, west: 0.32, ne: 0.109 },
  { period: 'Q3 19', south: 0.688, midwest: 0.176, west: 0.316, ne: 0.128 },
  { period: 'Q4 19', south: 0.73, midwest: 0.193, west: 0.365, ne: 0.122 },
  { period: 'Q1 20', south: 0.787, midwest: 0.171, west: 0.371, ne: 0.135 },
  { period: 'Q2 20', south: 0.579, midwest: 0.162, west: 0.261, ne: 0.078 },
  { period: 'Q3 20', south: 0.783, midwest: 0.225, west: 0.341, ne: 0.116 },
  { period: 'Q4 20', south: 0.82, midwest: 0.211, west: 0.414, ne: 0.122 },
  { period: 'Q1 21', south: 0.81, midwest: 0.205, west: 0.399, ne: 0.155 },
  { period: 'Q2 21', south: 0.82, midwest: 0.214, west: 0.401, ne: 0.149 },
  { period: 'Q3 21', south: 0.88, midwest: 0.198, west: 0.391, ne: 0.122 },
  { period: 'Q4 21', south: 0.881, midwest: 0.25, west: 0.414, ne: 0.123 },
  { period: 'Q1 22', south: 0.913, midwest: 0.221, west: 0.427, ne: 0.146 },
  { period: 'Q2 22', south: 0.919, midwest: 0.217, west: 0.371, ne: 0.13 },
  { period: 'Q3 22', south: 0.755, midwest: 0.187, west: 0.356, ne: 0.167 },
  { period: 'Q4 22', south: 0.739, midwest: 0.2, west: 0.327, ne: 0.126 },
  { period: 'Q1 23', south: 0.795, midwest: 0.148, west: 0.294, ne: 0.136 },
  { period: 'Q2 23', south: 0.819, midwest: 0.201, west: 0.331, ne: 0.107 },
  { period: 'Q3 23', south: 0.775, midwest: 0.178, west: 0.323, ne: 0.108 },
  { period: 'Q4 23', south: 0.782, midwest: 0.205, west: 0.37, ne: 0.112 },
  { period: 'Q1 24', south: 0.793, midwest: 0.175, west: 0.325, ne: 0.116 },
  { period: 'Q2 24', south: 0.768, midwest: 0.166, west: 0.301, ne: 0.107 },
  { period: 'Q3 24', south: 0.713, midwest: 0.19, west: 0.284, ne: 0.153 },
  { period: 'Q4 24', south: 0.749, midwest: 0.21, west: 0.302, ne: 0.127 },
  { period: 'Q1 25', south: 0.738, midwest: 0.176, west: 0.358, ne: 0.125 },
  { period: 'Q2 25', south: 0.718, midwest: 0.202, west: 0.282, ne: 0.154 },
  { period: 'Q3 25', south: 0.72, midwest: 0.218, west: 0.289, ne: 0.121 },
  { period: 'Q4 25', south: 0.712, midwest: 0.187, west: 0.279, ne: 0.145 },
  { period: 'Q1 26', south: 0.765, midwest: 0.183, west: 0.309, ne: 0.161 },
  { period: 'Q2 26', south: 0.706, midwest: 0.218, west: 0.292, ne: 0.129 },
  { period: 'Q3 26*', south: 0.663, midwest: 0.212, west: 0.283, ne: 0.135 },
];

/**
 * ARMA mill squares YoY, steep (U.S. shingles) vs low-slope (U.S. modified bitumen).
 * Same source, same unit. Only quarters with both prints.
 */
export const ARMA_STEEP_VS_LOWSLOPE = [
  { period: 'Q2 23', shingles: 13.6, modbit: 5.3 },
  { period: 'Q2 24', shingles: -9.6, modbit: 5.9 },
  { period: 'Q2 25', shingles: -4.3, modbit: -12.7 },
  { period: 'Q1 26', shingles: -9.9, modbit: -13.8 },
  { period: 'Q2 26', shingles: 0.2, modbit: 11.4 },
];

export const ARMA_MODBIT_Q2_26 = { squares: 12_497_481, yoy: 11.4 } as const;

/**
 * BLS PPI, quarterly average, rebased Q1 2019 = 100 so the three series share an axis.
 * Asphalt = mill input (WPU0576). Shingles = mill output (PCU324122324122). Lumber = Kodiak book (WPU081).
 */
export const INPUT_PPI = [
  { period: 'Q1 19', asphalt: 100.0, shingles: 100.0, lumber: 100.0 },
  { period: 'Q2 19', asphalt: 100.2, shingles: 100.4, lumber: 98.4 },
  { period: 'Q3 19', asphalt: 101.7, shingles: 100.3, lumber: 98.5 },
  { period: 'Q4 19', asphalt: 102.1, shingles: 101.0, lumber: 98.1 },
  { period: 'Q1 20', asphalt: 102.3, shingles: 101.8, lumber: 101.2 },
  { period: 'Q2 20', asphalt: 101.7, shingles: 100.9, lumber: 100.2 },
  { period: 'Q3 20', asphalt: 100.9, shingles: 103.1, lumber: 130.3 },
  { period: 'Q4 20', asphalt: 101.3, shingles: 102.9, lumber: 134.1 },
  { period: 'Q1 21', asphalt: 103.1, shingles: 104.8, lumber: 162.6 },
  { period: 'Q2 21', asphalt: 107.6, shingles: 110.4, lumber: 202.8 },
  { period: 'Q3 21', asphalt: 111.5, shingles: 115.7, lumber: 139.8 },
  { period: 'Q4 21', asphalt: 116.1, shingles: 119.8, lumber: 146.1 },
  { period: 'Q1 22', asphalt: 117.9, shingles: 125.9, lumber: 198.9 },
  { period: 'Q2 22', asphalt: 126.7, shingles: 131.1, lumber: 171.7 },
  { period: 'Q3 22', asphalt: 137.7, shingles: 133.6, lumber: 143.7 },
  { period: 'Q4 22', asphalt: 142.9, shingles: 135.2, lumber: 128.9 },
  { period: 'Q1 23', asphalt: 142.6, shingles: 131.9, lumber: 124.2 },
  { period: 'Q2 23', asphalt: 142.2, shingles: 135.9, lumber: 122.1 },
  { period: 'Q3 23', asphalt: 142.4, shingles: 138.4, lumber: 122.7 },
  { period: 'Q4 23', asphalt: 141.7, shingles: 139.2, lumber: 114.4 },
  { period: 'Q1 24', asphalt: 142.3, shingles: 139.5, lumber: 116.8 },
  { period: 'Q2 24', asphalt: 141.3, shingles: 139.3, lumber: 118.2 },
  { period: 'Q3 24', asphalt: 141.2, shingles: 139.7, lumber: 118.0 },
  { period: 'Q4 24', asphalt: 141.3, shingles: 141.8, lumber: 123.2 },
  { period: 'Q1 25', asphalt: 141.0, shingles: 139.9, lumber: 127.0 },
  { period: 'Q2 25', asphalt: 140.7, shingles: 141.8, lumber: 126.8 },
  { period: 'Q3 25', asphalt: 140.8, shingles: 143.5, lumber: 123.6 },
  { period: 'Q4 25', asphalt: 140.8, shingles: 142.8, lumber: 121.7 },
  { period: 'Q1 26', asphalt: 139.8, shingles: 139.8, lumber: 126.4 },
  { period: 'Q2 26', asphalt: 149.9, shingles: 143.2, lumber: 131.7 },
  { period: 'Q3 26*', asphalt: 161.9, shingles: 150.4, lumber: 135.5 },
];

export const PPI_LATEST = {
  month: 'Aug 2026',
  asphaltYoy: 14.9,
  shingleYoy: 4.7,
  lumberYoy: 7.6,
} as const;

/** IBP installation same-branch, residential vs commercial. Filings. */
export const IBP_INSTALL_SPLIT = [
  { period: 'Q1 25', resi: -4.6, comm: -2.8 },
  { period: 'Q2 25', resi: -1.1, comm: 9.3 },
  { period: 'Q3 25', resi: -2.8, comm: 11.7 },
  { period: 'Q4 25', resi: -9.3, comm: 22.9 },
  { period: 'Q1 26', resi: -11.2, comm: 10.7 },
  { period: 'Q2 26', resi: -6.1, comm: 10.4 },
];

/** TopBuild same-branch residential vs C/I. Only quarters with a published split. */
export const TOPBUILD_SB = [
  { period: 'Q3 25', resi: -10.0, ci: 0.2 },
  { period: 'Q4 25', resi: -14.4, ci: -1.7 },
];

export const TOPBUILD_FY25_SB = { resi: -10.8, ci: -0.9 } as const;

/** BLDR core organic by end market. Sparse on purpose. */
export const BLDR_END_MARKET = [
  { period: 'Q4 25', sf: -15.4, mf: -20.4, rr: -6.5, core: -14.0 },
  { period: 'Q1 26', sf: -11.0, mf: -1.0, rr: -1.0, core: null as number | null },
  { period: 'Q2 26', sf: -8.1, mf: -9.7, rr: -1.8, core: -7.0 },
];

/**
 * Reported sales mix %. Q2 24 is Beacon standalone. Q2 25 is QXO with two months of Beacon.
 * Q2 26 includes a full quarter of Kodiak — complementary jumps because of lumber, not Beacon mix shift.
 */
export const REPORTED_MIX = [
  { period: 'Q2 24 Beacon', resi: 49.7, nonresi: 27.9, complementary: 22.4 },
  { period: 'Q2 25 QXO', resi: 48.7, nonresi: 28.1, complementary: 22.4 },
  { period: 'Q2 26 QXO+Kodiak', resi: 39.0, nonresi: 22.7, complementary: 37.9 },
];

export const AIA_ABI = {
  month: 'Jul 2026',
  score: 46.6,
  note: 'Below 50 = contraction. Commercial roofing pipeline, not a shipment number.',
} as const;

export const STACK_KPIS = [
  {
    id: 'modbit',
    label: 'Low-slope mill shipments, Q2 26',
    value: '+11.4%',
    hint: 'Modified bitumen · 12.5M squares',
    tone: 'success' as const,
  },
  {
    id: 'complete',
    label: 'Homes completed, Aug 26',
    value: '1.128M',
    hint: 'Annualized · −27% vs last year · houses 816k',
    tone: 'danger' as const,
  },
  {
    id: 'asphalt',
    label: 'Asphalt cost, Aug 26',
    value: '+14.9%',
    hint: 'vs last year · mill shingle prices +4.7%',
    tone: 'warning' as const,
  },
  {
    id: 'bld',
    label: 'TopBuild residential jobs, Q4 25',
    value: '−14.4%',
    hint: 'Same-branch · commercial −1.7% · full-year residential −10.8%',
    tone: 'danger' as const,
  },
  {
    id: 'south',
    label: 'South home starts, Aug 26',
    value: '0.658M',
    hint: 'Annualized · −1.2% vs last year · storm belt',
    tone: 'warning' as const,
  },
  {
    id: 'abi',
    label: 'Architecture billings, Jul 26',
    value: '46.6',
    hint: 'Below 50 means design firms are contracting',
    tone: 'warning' as const,
  },
];
